export default __webpack_public_path__ + "static/media/EpisPost.2d16726a.png";